
export const changelog = [
    {
        type: "new",
        audience: "sterilis",
        desc: "Added New Bottles Waste Type",
        details:
            "Added a new waste type for bottles.",
        images: [],
    },
    {
        type: "fix",
        audience: "sterilis",
        desc: "Fixed issue with date range logic in compliance and comprehensive reports",
        details:
            "Fixed an issue with the date range logic in compliance and comprehensive reports including cycles outside of selected range.",
        images: [],
    },
    {
        type: "chg",
        audience: "sterilis",
        desc: "Added Customer Name To Cycle Reports",
        details:
            "Added the customer name to cycle reports for better identification.",
        images: [],
    },
];
